import { render, staticRenderFns } from "./CustomSort.vue?vue&type=template&id=7ceba32b&scoped=true"
import script from "./CustomSort.vue?vue&type=script&lang=js"
export * from "./CustomSort.vue?vue&type=script&lang=js"
import style0 from "./CustomSort.vue?vue&type=style&index=0&id=7ceba32b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ceba32b",
  null
  
)

export default component.exports